import {createSlice} from '@reduxjs/toolkit'

export const productReviewInitialState = {
  formData: {
    activeDisplay: true,
  },
  displayContent: {
    en: {
      newDisplayTitle: '',
      parentCategory: '',
      childCategory: '',
      excerpt: '',
      terms: '',
    },
  },
  displayContentMedia: {
    title: '',
    imageId: '',
    imageUri: '',
    imageBase64: '',
    optIn: false,
  },
  selectedCategory: [],
  excludedProducts: [],
  includedProducts: [],
}

const productReviewSlice = createSlice({
  name: 'productReview',
  initialState: productReviewInitialState,
  reducers: {
    setProductReviewDisplayContent: (state, action) => {
      return {
        ...state,
        displayContent: action.payload,
      }
    },
    resetProductReview: () => productReviewInitialState,
    setProductReviewDisplayContentMedia: (state, action) => {
      return {
        ...state,
        displayContentMedia: action.payload,
      }
    },
    resetProductReviewDisplayContentMedia: state => {
      return {
        ...state,
        displayContentMedia: {
          title: '',
          imageId: '',
          imageUri: '',
          imageBase64: '',
        },
      }
    },
    setProductReviewFormData: (state, action) => {
      return {
        ...state,
        formData: action.payload,
      }
    },
    setProductReviewSelectedCategory: (state, action) => {
      return {
        ...state,
        selectedCategory: action.payload,
      }
    },
    addExcludedProduct: (state, action) => {
      const productId = action.payload
      state.includedProducts = state.includedProducts.filter(id => id !== productId)
      if (!state.excludedProducts.includes(productId)) {
        state.excludedProducts.push(productId)
      }
    },
    removeExcludedProduct: (state, action) => {
      state.excludedProducts = state.excludedProducts.filter(id => id !== action.payload)
    },
    addIncludedProduct: (state, action) => {
      const productId = action.payload
      state.excludedProducts = state.excludedProducts.filter(id => id !== productId)
      if (!state.includedProducts.includes(productId)) {
        state.includedProducts.push(productId)
      }
    },
    removeIncludedProduct: (state, action) => {
      state.includedProducts = state.includedProducts.filter(id => id !== action.payload)
    },
  },
})

export const {
  setProductReviewDisplayContent,
  setProductReviewDisplayContentMedia,
  resetProductReviewDisplayContentMedia,
  resetProductReview,
  setProductReviewFormData,
  setProductReviewSelectedCategory,
  addExcludedProduct,
  removeExcludedProduct,
  addIncludedProduct,
  removeIncludedProduct,
} = productReviewSlice.actions

export const productReviewSliceReducer = productReviewSlice.reducer
